export const SET_APP_MESSAGE = 'SET_APP_MESSAGE'

export const setAppMessage = data => ({
	type: SET_APP_MESSAGE,
	delay: data.delay,
	messageType: data.type,
	text: data.text,
})
